export const DESKTOP_NAV_ITEM_GAP_PX = 8;

type CountVisibleDesktopNavItemsInput = {
  itemWidths: number[];
  moreWidth: number;
  gap?: number;
  available: number;
};

function totalWidth(widths: number[], gap: number) {
  if (widths.length === 0) return 0;
  return widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1);
}

export function countVisibleDesktopNavItems({
  itemWidths,
  moreWidth,
  gap = DESKTOP_NAV_ITEM_GAP_PX,
  available
}: CountVisibleDesktopNavItemsInput) {
  if (itemWidths.length === 0 || available <= 0) return 0;

  if (totalWidth(itemWidths, gap) <= available) return itemWidths.length;

  for (let count = itemWidths.length - 1; count >= 0; count -= 1) {
    const visibleWidths = itemWidths.slice(0, count);
    if (totalWidth([...visibleWidths, moreWidth], gap) <= available) return count;
  }

  return 0;
}

export function isDesktopNavLinkActive(label: string, to: string, pathname: string) {
  if (label === "Home") return pathname === "/home";
  if (label === "Sections") return pathname.startsWith("/sections");
  return pathname.startsWith(to);
}
